import { CommentLikeInterface } from "../interfaces/comments/CommentLikeInterface";

export class CommentLike implements CommentLikeInterface {
    count: number;
    rating: number | null;

    constructor(data: CommentLikeInterface) {
        Object.assign(this, data);
    }
}
